import React from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Image from "next/image";
import LocationIcon from "../../public/images/icons/Vector.png";
import darkTheme from '../../src/theme';
import Link from 'next/link'

const venueCard = {
  borderTop: `1px dotted`,
  borderColor: `#2F2F2F`,
  paddingTop: darkTheme.spacing(2),
  marginTop: darkTheme.spacing(2),
  marginBottom: darkTheme.spacing(3),
  '& h5': {
      fontSize: 14,
      textTransform: 'capitalize',    
      color: darkTheme.palette.primary.dates,       
      fontWeight: 400,    
      marginBottom: darkTheme.spacing(1),
  },
  '& h6': {
      fontSize: 20,
      color: darkTheme.palette.primary.main,
      fontWeight: 400,       
      marginBottom: darkTheme.spacing(0.5),
      textDecoration: 'none !important', 
  },  
  '& a': {
    fontSize: 14,
    color: darkTheme.palette.primary.location,
    textDecoration: 'underline',   
    ':hover': {
      color: darkTheme.palette.primary.title,
      textDecoration: 'underline',    
    }
  }
};


function Venue({data}) {      
console.log('----------data')
console.log(data)
  return (
    <>            
        <Typography component="div" sx={venueCard}>
            <Stack
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    alignItems:'center'
                }}
            >
                <Typography component="div" sx={{ maxWidth: "80%" }}>
                  <Typography variant="h5">Hosted By</Typography>
                  {data.is_event ? (
                    <Typography variant="h6">{data.clubName}</Typography>
                  ) : (
                      <Link href={"/venue/" + data.clubSlug+'/'+data.clubId} passHref>
                        <a style={{textDecoration:'none'}}>
                          <Typography variant="h6">{data.clubName}</Typography>
                        </a>
                      </Link>
                  )}
                    
                      {/* <Link href={'https://google.com/maps?q='+data.latitude+","+data.longitude} passHref> */}
                        {/* <a target="_blank" rel="noopener noreferrer"> */}
                          {data.event_venue ? (
                            <>
                              <Image
                                src={LocationIcon}
                                alt=""
                                width={12}
                                height={14}
                                layout="fixed"
                              />
                              &nbsp;
                              {data.event_venue}
                            </>
                          ):(
                            <>
                            {data.cityName && (
                              <>
                                <Image
                                  src={LocationIcon}
                                  alt=""
                                  width={12}
                                  height={14}
                                  layout="fixed"
                                />
                                &nbsp;
                                {data.area_name ? data.area_name+ ", " : ""} 
                                {data.cityName}
                              </>
                            )}
                            </>
                          )}
                        {/* </a> */}
                      {/* </Link> */}
                          {/* {data.event_venue && (
                          <>
                            <Image
                              src={LocationIcon}
                              alt=""
                              width={12}
                              height={14}
                              layout="fixed"
                            />
                            &nbsp;
                            {data.event_venue}
                          </>
                        )} */}
                     
                      
                 </Typography>
                 {!data.is_event ? (
                <Typography component="div">
                  <Link href={'https://google.com/maps?q='+data.latitude+","+data.longitude} passHref>
                    <a target="_blank" rel="noopener noreferrer"><Image
                      src="/images/icons/Map.svg"
                      alt="..."
                      width={60}
                      height={60}
                    /></a>
                  </Link>
                </Typography>
                 ):(
                  <Typography component="div">
                    <Image
                      src="/images/icons/Map.svg"
                      alt="..."
                      width={60}
                      height={60}
                    />
                </Typography>
                 )}
            </Stack>
        </Typography>        
    </>
  );
}

export default Venue;
